
define(['jquery'],function($){
  return {
    deferred: $.Deferred,
    when: $.when,
    ajax: $.ajax
  };
});

